import React, { useEffect } from 'react';
import { Button } from './ui/button';
import { ChevronRight } from 'lucide-react';

export const SponsorsSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.scroll-reveal').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // UPDATED SPONSORS - Camden Council same size, inverted hover states
  const sponsors = [
    { 
      name: 'Camden Council', 
      logo: 'https://customer-assets.emergentagent.com/job_festival-prototype/artifacts/rejjm682_Camden-Council-Logo-Trans_inv.png',
      isImage: true
    },
    { name: 'Future Sponsor 1', isImage: false },
    { name: 'Future Sponsor 2', isImage: false },
    { name: 'Future Sponsor 3', isImage: false },
    { name: 'Future Sponsor 4', isImage: false },
    { name: 'Future Sponsor 5', isImage: false },
  ];

  return (
    <section id="sponsors" className="section-full py-16 md:py-20 border-t border-border">
      <div className="container-wide">
        <div className="text-center mb-12 md:mb-16 scroll-reveal">
          <p className="text-sm uppercase tracking-widest font-bold text-muted-foreground mb-4">Proudly Supported By</p>
          <h2 className="text-4xl md:text-5xl font-black" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            OUR SPONSORS
          </h2>
        </div>

        {/* Sponsor Grid - FIXED SIZE, INVERTED HOVER STATES */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8 mb-12 md:mb-16 scroll-reveal">
          {sponsors.map((sponsor, index) => (
            <div 
              key={index}
              className="aspect-square bg-foreground flex items-center justify-center p-4 group hover:bg-[#c3d941] transition-all duration-300 cursor-pointer"
            >
              {sponsor.isImage ? (
                <img 
                  src={sponsor.logo} 
                  alt={sponsor.name}
                  className="w-full h-full object-contain p-2"
                />
              ) : (
                <div className="text-center">
                  <span className="font-black text-base md:text-lg text-background group-hover:text-foreground transition-colors px-2 block">
                    {sponsor.name}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Become a Sponsor CTA */}
        <div className="text-center scroll-reveal">
          <div className="max-w-2xl mx-auto bg-muted p-8 md:p-12">
            <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              BECOME A SPONSOR
            </h3>
            <p className="text-base md:text-lg text-muted-foreground mb-8 leading-relaxed">
              Partner with Run Camden and reach thousands of passionate runners. Join our community of sponsors supporting Camden's premier running festival.
            </p>
            <Button className="btn-standard group w-full sm:w-auto">
              Partner With Us
              <ChevronRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
